import React from "react";
import { motion } from "framer-motion";
import CTAButton from "../CTAButton";

const FinalCTASection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Seats are limited. Don't miss this chance to transform your salon's growth!
          </h2>
          {/* <p className="text-xl text-gray-300 mb-8">
            👉 Register Now at Just ₹299/-
          </p> */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <CTAButton
              text="REGISTER NOW AT ₹299/- ONLY"
              calendlyUrl="https://calendly.com/zylusales/group-growth-consultation?hide_gdpr_banner=1"
              className="text-xl py-4 px-12 uppercase tracking-wide"
              icon={false}
              isWebinarRegistration={true}
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
